/**
 * Read a query param without treating "+" as a space.
 *
 * URLSearchParams follows application/x-www-form-urlencoded rules where "+"
 * means space. Email addresses can contain "+" (e.g. user+tag@gmail.com), so
 * links must encode "+" as %2B and this helper preserves literal "+" when they
 * were not encoded.
 */
export function getQueryParam(search: string, key: string): string | null {
  const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = search.match(new RegExp(`(?:^|[?&])${escapedKey}=([^&]*)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}
